module.exports = __webpack_public_path__ + "img/news_background.8b02c38e.png";